/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import _ from 'lodash';

export const TableModule = BaseControl.extend({
    init: function () {
        this._super();
        this.initTable();
    },

    initTable: function () {
        const $table = this.$element.find('table');
        const $tableMobile = this.$element.find('.s-table--mobile');
        let columnsTitles = $table.find('th').map((i, cell) => $(cell).html());

        $table.addClass('s-table');

        if (columnsTitles.length === 0) {
            columnsTitles = $table.find('tr:first td').map((i, cell) => $(cell).html());
        }

        $table.find('tr:not(:first)').each((i, row) => {
            const cellGroups = _.zip(columnsTitles, $(row).find('td').map((i, cell) => $(cell).html()));
            let lastRow, firstRow;

            _.forEach(cellGroups, (cellGroup) => {
                if (!firstRow) {
                    firstRow = $('<tr>');
                    $tableMobile.append(firstRow.append(cellGroup.map(html => `<td>${html}</td>`)));
                } else {
                    lastRow = $('<tr>');
                    $tableMobile.append(lastRow.append(cellGroup.map(html => `<td>${html}</td>`)));
                }
            });
            
            if (firstRow) {
                firstRow.addClass('is-first-in-group');
            }

            if (lastRow) {
                lastRow.addClass('is-last-in-group');
            }
        });
    }
});
